/* eslint-disable */
<template>
  <div :id="'container' + id" class="textfieldScreen">
    <div class="leftContent">
      <custom-header :img-number="headerImg"></custom-header>
    </div>
    <div class="rightContent">
      <div class="headBlock">
        <custom-header />
      </div>
      <div class="wrap textfieldScreen_content">
        <div class="grow"></div>
        <h2 v-html="title"></h2>
        <p v-if="text" v-html="text"></p>
        <login-input
          :id="'textfield' + id"
          :name="'textfield' + id"
          :placeholder="placeholder"
          v-model="inputValue"
          :is-not-valid="isNotValid"
          :valid-message="isNotValidMessage"
          :type="inputType"
          :inputmode="inputmode"
          :maxlength="maxlength"
          :autocomplete="autocomplete"
          @keydown.native.enter="next"
          @blur="$listeners.blur ? $listeners.blur() : null"
        ></login-input>

        <!--:mask="getMask(inputValue)"-->

        <slot name="middle"></slot>
        <div class="grow"></div>
        <div class="bottom">
          <div class="left">
            <custom-button :button-text="$ml.get('back')" back :action="back"></custom-button>
          </div>
          <div class="right">
            <custom-button ref="nextBtn" :button-text="$ml.get('next')" success :disabled="disabledButton || disabledNextButton" :action="next"></custom-button>
          </div>
        </div>
        <div class="bottomLink">
          <slot name="bottomLink"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoginInput from '../ui/login-input';
import CustomHeader from '../ui/custom-header';
import CustomButton from '../ui/custom-button';
export default {
  name: 'textfield-screen',
  components: {CustomButton, CustomHeader, LoginInput},
  props: {
    value: String,
    id: String,
    title: String,
    text: String,
    placeholder: String,
    inputType: String,
    inputmode: String,
    isNotValid: Boolean,
    isNotValidMessage: String,
    disabledNextButton: Boolean,
    defaultValue: String,
    maxlength: Number,
    headerImg: Number,
    autocomplete: String,
  },
  data() {
    return {
      inputValue: this.defaultValue || this.value || '',
    };
  },

  computed: {
    disabledButton: function() {
      return this.inputValue.length === 0;
    },
  },

  watch: {
    value: function(val) {
      this.inputValue = val;
    },

    inputValue: function(val) {
      if (val.length) {
        if (!this.getMask(val)) {
          if (val.match(/^.+@([\w\-]+\.){0,3}[a-z]{2,7}$/i)) {
            this.$emit('input', val);
          } else {
          }
        }
        if (this.inputType === 'calendar') {
          this.$refs.nextBtn.$el.focus();
        }
        this.$emit('input', val);
      } else {
        this.$emit('input', val);
      }
    },
  },

  methods: {
    back: function() {
      this.$emit('back', true);
    },
    next: function() {
      this.$emit('next', {value: this.inputValue});
    },
    getMask: function(val) {
      // return null;
      if (this.inputType === 'calendar') {
        return [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
        // return null;
      }
      // if (this.inputType === 'password') {
      //     return null;
      // }
      else {
        // if (val.replace(/\D/g, '').length === val.length) {
        if (/^380/.test(val)) {
          // return ['+', /\d/,/\d/,' ','(', /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, ' ', /\d/, /\d/]
          return ['+', /\w/, /\w/, ' ', '(', /\w/, /\w/, /\w/, ')', ' ', /\w/, /\w/, /\w/, ' ', /\w/, /\w/, ' ', /\w/, /\w/];
        } else if (/^0/.test(val)) {
          // return ['+', '3','8',' ','(', /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, ' ', /\d/, /\d/]
          return ['+', '3', '8', ' ', '(', /\w/, /\w/, /\w/, ')', ' ', /\w/, /\w/, /\w/, ' ', /\w/, /\w/, ' ', /\w/, /\w/];
        } else if (/^80/.test(val)) {
          return ['+', '3', /\d/, ' ', '(', /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, ' ', /\d/, /\d/];
        } else if (/^7/.test(val)) {
          return ['+', /\d/, ' ', '(', /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, ' ', /\d/, /\d/];
        } else {
          return null;
        }
        // } else
        //     return null;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.textfieldScreen_content {
  display: flex;
  flex-direction: column;
  /*height: 500px;*/
  /*justify-content: stretch;*/
  justify-content: space-between;
  min-height: calc(100vh - 150px);
}
.bottom {
  /*margin-bottom: 32px;*/
  .left {
    width: 40%;
    float: left;
  }
  .right {
    width: 56%;
    float: right;
  }
}
@media (max-width: 320px) {
}
@media (min-width: 321px) and (max-width: 600px) {
}
@media (min-width: 601px) and (max-width: 750px) {
  .textfieldScreen_content {
    height: calc(100vh - 160px);
    max-height: 700px;
  }
}
@media (min-width: 751px) {
  .textfieldScreen_content {
    height: calc(100vh - 160px);
    max-height: 700px;
  }
}
</style>
